import { MessageIcon, CloseIcon } from './constants/ai-icon.js'
import { getUserInfo, getAppBaseConfig } from '@/storage/services/AppBaseConfigService.js'
import storeCEM from '@/hotelcem/store/index.js'
import authService from '@/hotelcem/apis/auth/authService.js'

let aiType = 'ACTION-AI-SERVICE'
let currentOriginUrl = ''

let env = process.env.VUE_APP_ENV
const urlMap = {
  'ACTION-AI-SERVICE': {
    dev: 'https://help-fat.cemsmart.com/chat/share?shareId=woahclzvutr7myj2jifp80qu',
    fat: 'https://help-fat.cemsmart.com/chat/share?shareId=woahclzvutr7myj2jifp80qu',
    uat: 'https://help-fat.cemsmart.com/chat/share?shareId=woahclzvutr7myj2jifp80qu',
    prod: 'https://help.vocust.com/chat/share?shareId=vmey5mfshj28b7vbixxnceo9',
  },
  'ACTION-AI-SERVICE-BETA': {
    dev: 'https://help-fat.cemsmart.com/chat/share?shareId=bpJmFs47sWyaFGd3ZdfmRZHk',
    fat: 'https://help-fat.cemsmart.com/chat/share?shareId=bpJmFs47sWyaFGd3ZdfmRZHk',
    uat: 'https://help-fat.cemsmart.com/chat/share?shareId=bpJmFs47sWyaFGd3ZdfmRZHk',
    prod: 'https://help-v2.vocust.com/chat/share?shareId=sOHESJHLkQloax3IPpHePGAv',
  },
}

async function getUrl(type) {
  let tokenInfo = await authService.getAIToken()
  let token
  if (tokenInfo?.code === 200) {
    token = tokenInfo.data?.signToken
  }
  let info = getAppBaseConfig()
  let hotelName = storeCEM.getters.hotelInfo?.hotelName
  let xhotelId = storeCEM.getters.dateFilter?.hotelInfo?.value
  let nickname = encodeURIComponent(encodeURIComponent(hotelName + '-' + info?.userInfo?.userName))
  let tenantId = info?.userInfo?.tenantId
  let scriptUrl = urlMap[type][env]
  if (!scriptUrl) {
    console.error('scriptUrl is required')
    return
  }
  scriptUrl += `&agentUid=${info?.userInfo?.userId}&nickname=${nickname}&tenantId=${tenantId}`
  currentOriginUrl = scriptUrl
  scriptUrl += `&token=${token}&xhotelId=${xhotelId}`
  return scriptUrl
}

export async function createDraggableIframe(type) {
  const chatBtnId = 'draggable-iframe-button'
  const chatWindowId = 'draggable-iframe-window'
  let iframeSrc = await getUrl(type)

  if (!iframeSrc) {
    console.error('iframeSrc is required')
    return
  }
  if (type === 'ACTION-AI-SERVICE-BETA' && document.getElementById(chatWindowId)) {
    hanldeIframeChangeSrc()
  }
  if (document.getElementById(chatBtnId)) {
    return
  }

  const ChatBtn = document.createElement('div')
  ChatBtn.id = chatBtnId
  ChatBtn.style.cssText = `
    border-radius: 8px;
    overflow: hidden;
    position: fixed;
    bottom: 10vh;
    right: 8px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 2147483647;
    transition: 0;
    touch-action: none;
    will-change: 'transform';
    box-shadow: 0 2px 0.75rem 0 rgba(0, 0, 0, 0.3);
  `
  // Mobile styles
  const mobileStyle = `
    @media (max-width: 1024px) {
      #${chatWindowId} {
        width: 90vw!important;
        height: 80vh!important;
        bottom: 120px!important;
        right: 20px!important;
      }
      #${chatBtnId} {
        width: 40px!important;
        height: 40px!important;
        border-radius: 4px!important;
      }
    }
  `
  const styleEl = document.createElement('style')
  styleEl.textContent = mobileStyle
  document.head.appendChild(styleEl)

  const ChatBtnDiv = document.createElement('img')
  ChatBtnDiv.src = MessageIcon
  ChatBtnDiv.style.borderRadius = '4px'
  ChatBtnDiv.setAttribute('width', '100%')
  ChatBtnDiv.setAttribute('height', '100%')
  ChatBtnDiv.draggable = false

  let iframe = document.getElementById(chatWindowId)
  if (!iframe) {
    iframe = document.createElement('iframe')
    iframe.allow = '*'
    iframe.referrerPolicy = 'no-referrer'
    iframe.title = 'Draggable Iframe'
    iframe.id = chatWindowId
    iframe.src = iframeSrc
    iframe.style.cssText =
      'border: none; position: fixed; bottom: 80px; right: 60px; width: 80vw; height: 80vh; max-width: 90vw; max-height: 85vh; border-radius: 0.75rem; z-index: 2147483647; overflow: hidden; background-color: #F3F4F6;'
    iframe.style.visibility = 'hidden'
    document.body.appendChild(iframe)

    // 创建蒙层元素
    const overlay = document.createElement('div')
    overlay.id = 'iframe-overlay'
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 2147483646;
      display: none;
    `
    // overlay.addEventListener('click', () => {
    //   iframe.style.visibility = 'hidden'
    //   ChatBtnDiv.src = MessageIcon
    //   overlay.style.display = 'none'
    // })
    document.body.appendChild(overlay)
  }

  let chatBtnDragged = false
  let chatBtnDown = false
  let chatBtnMouseX
  let chatBtnMouseY
  let chatBtnStartX
  let chatBtnStartY
  let currentTransform = { x: 0, y: 0 }
  let touchStartTime = 0
  let isClick = false
  const dragThreshold = 5 // pixels

  // 移除click事件监听，改为在mouseup中处理点击

  function handleMouseMove(e) {
    if (!chatBtnDown) return

    // 只有移动距离超过阈值才认为是拖拽
    const dx = Math.abs(e.clientX - chatBtnStartX)
    const dy = Math.abs(e.clientY - chatBtnStartY)
    if (dx > dragThreshold || dy > dragThreshold) {
      chatBtnDragged = true
    }

    const transformX = currentTransform.x + (e.clientX - chatBtnMouseX)
    const transformY = currentTransform.y + (e.clientY - chatBtnMouseY)

    ChatBtn.style.transform = `translate3d(${transformX}px, ${transformY}px, 0)`
    currentTransform = { x: transformX, y: transformY }
    chatBtnMouseX = e.clientX
    chatBtnMouseY = e.clientY
  }

  function handleMouseUp(e) {
    if (chatBtnDown) {
      const dx = Math.abs(e.clientX - chatBtnStartX)
      const dy = Math.abs(e.clientY - chatBtnStartY)
      chatBtnDragged = dx > dragThreshold || dy > dragThreshold

      if (!chatBtnDragged && isClick) {
        const visibilityVal = iframe.style.visibility
        if (visibilityVal === 'hidden') {
          iframe.style.visibility = 'unset'
          ChatBtnDiv.src = CloseIcon
          document.getElementById('iframe-overlay').style.display = 'block'
        } else {
          iframe.style.visibility = 'hidden'
          ChatBtnDiv.src = MessageIcon
          document.getElementById('iframe-overlay').style.display = 'none'
        }
      }
    }
    chatBtnDown = false
    isClick = false

    // 移除全局事件监听器
    document.removeEventListener('mousemove', handleMouseMove)
    document.removeEventListener('mouseup', handleMouseUp)
  }

  ChatBtn.addEventListener('mousedown', e => {
    e.stopPropagation()
    chatBtnMouseX = e.clientX
    chatBtnMouseY = e.clientY
    chatBtnStartX = e.clientX
    chatBtnStartY = e.clientY
    chatBtnDown = true
    chatBtnDragged = false
    isClick = true

    // 添加全局事件监听器
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
  })

  // Mobile touch events
  function handleTouchMove(e) {
    e.preventDefault()
    e.stopPropagation()
    if (!chatBtnDown) return

    const touch = e.touches[0]

    // 只有移动距离超过阈值才认为是拖拽
    const dx = Math.abs(touch.clientX - chatBtnStartX)
    const dy = Math.abs(touch.clientY - chatBtnStartY)
    if (dx > dragThreshold || dy > dragThreshold) {
      chatBtnDragged = true
    }

    const transformX = currentTransform.x + (touch.clientX - chatBtnMouseX)
    const transformY = currentTransform.y + (touch.clientY - chatBtnMouseY)

    ChatBtn.style.transform = `translate3d(${transformX}px, ${transformY}px, 0)`
    currentTransform = { x: transformX, y: transformY }
    chatBtnMouseX = touch.clientX
    chatBtnMouseY = touch.clientY
  }

  function handleTouchEnd(e) {
    const touch = e.changedTouches && e.changedTouches[0]
    if (!touch) {
      chatBtnDown = false
      chatBtnDragged = false
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchend', handleTouchEnd)
      return
    }

    const dx = Math.abs(touch.clientX - chatBtnStartX)
    const dy = Math.abs(touch.clientY - chatBtnStartY)
    const touchDuration = Date.now() - touchStartTime

    // 使用统一的拖拽阈值和适中的触摸时长
    const touchDragThreshold = 8 // 比PC端稍大，适应手指触摸的精度
    const isRealClick = !chatBtnDragged && dx <= touchDragThreshold && dy <= touchDragThreshold && touchDuration < 400

    if (isRealClick) {
      const visibilityVal = iframe.style.visibility
      if (visibilityVal === 'hidden' || visibilityVal === '') {
        iframe.style.visibility = 'unset'
        ChatBtnDiv.src = CloseIcon
        document.getElementById('iframe-overlay').style.display = 'block'
      } else {
        iframe.style.visibility = 'hidden'
        ChatBtnDiv.src = MessageIcon
        document.getElementById('iframe-overlay').style.display = 'none'
      }
    }
    chatBtnDown = false
    chatBtnDragged = false

    // 移除全局事件监听器
    document.removeEventListener('touchmove', handleTouchMove)
    document.removeEventListener('touchend', handleTouchEnd)
  }

  ChatBtn.addEventListener(
    'touchstart',
    e => {
      e.preventDefault()
      e.stopPropagation()
      const touch = e.touches[0]
      chatBtnMouseX = touch.clientX
      chatBtnMouseY = touch.clientY
      chatBtnStartX = touch.clientX // 记录触摸起始位置
      chatBtnStartY = touch.clientY // 记录触摸起始位置
      chatBtnDown = true
      chatBtnDragged = false // 重置拖动状态
      touchStartTime = Date.now()

      // 添加全局事件监听器
      document.addEventListener('touchmove', handleTouchMove, { passive: false })
      document.addEventListener('touchend', handleTouchEnd)
    },
    { passive: false }
  )

  ChatBtn.appendChild(ChatBtnDiv)
  document.body.appendChild(ChatBtn)
}

export function handleIframeFastgpt(text) {
  const iframe = document.querySelector('#draggable-iframe-window')
  const visibilityVal = iframe.style.visibility
  const ChatBtnDiv = document.querySelector('#draggable-iframe-button img')
  if (visibilityVal === 'hidden') {
    iframe.style.visibility = 'unset'
    ChatBtnDiv.src = CloseIcon
  }
  if (text) {
    iframe.contentWindow.postMessage(
      {
        type: 'text',
        text,
      },
      iframe.src
    )
  }
}

export async function hanldeIframeChangeSrc() {
  let tokenInfo = await authService.getAIToken()
  let token
  if (tokenInfo.code === 200) {
    token = tokenInfo.data?.signToken
  }
  let iframe = document.getElementById('draggable-iframe-window')
  let xhotelId = storeCEM.getters.dateFilter?.hotelInfo?.value
  if (xhotelId) {
    iframe.src = currentOriginUrl + `&xhotelId=${xhotelId}&token=${token}`
  }
}
